'use client';
import { createBareContext } from '@s7/react-utils';

const [ImageProvider, useImageContext] = createBareContext();

export { ImageProvider, useImageContext };
//# sourceMappingURL=ImageProvider.js.map
